import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { Mail, ArrowRight, CheckCircle2, AlertCircle, ArrowLeft } from 'lucide-react';

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = 'Forgot Password | Sport Fitt Pro';
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter your email');
      return;
    }
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />

      <main className="flex-1 pt-[104px] flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Link to="/login" className="inline-flex items-center gap-2 text-ink-500 hover:text-athletic-500 text-sm font-bold uppercase tracking-wider mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to Sign In
          </Link>

          {submitted ? (
            <div className="text-center py-10">
              <div className="w-20 h-20 bg-athletic-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle2 className="w-10 h-10 text-white" />
              </div>
              <p className="text-athletic-500 text-[11px] font-black tracking-[0.4em] uppercase mb-3">Email Sent</p>
              <h1 className="font-display text-4xl text-ink-900 tracking-wider leading-none mb-4">CHECK YOUR INBOX</h1>
              <p className="text-ink-500 mb-8">We've sent a reset link to <strong className="text-ink-900">{email}</strong>. Check your inbox and follow the instructions.</p>
              <Link to="/login" className="inline-flex items-center gap-2 px-6 py-3 bg-athletic-500 text-white font-black uppercase tracking-wider text-sm hover:bg-athletic-600 transition-colors">
                Back to Sign In
              </Link>
            </div>
          ) : (
            <>
              <div className="mb-8">
                <p className="text-athletic-500 text-[11px] font-black tracking-[0.4em] uppercase mb-3">Password Reset</p>
                <h1 className="font-display text-5xl text-ink-900 tracking-wider leading-none mb-3">FORGOT<br /><span className="text-athletic-500">PASSWORD?</span></h1>
                <p className="text-ink-500">Enter your email and we'll send you a link to reset your password.</p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5">
                {error && (
                  <div className="flex items-start gap-2 px-4 py-3 bg-athletic-50 border-2 border-athletic-100 text-athletic-700">
                    <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                    <span className="text-sm font-medium">{error}</span>
                  </div>
                )}
                <div>
                  <label className="block text-[11px] font-black uppercase tracking-wider text-ink-900 mb-2">Email Address</label>
                  <div className="relative">
                    <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-400" />
                    <input type="email" value={email} onChange={(e) => { setEmail(e.target.value); setError(''); }} placeholder="you@example.com" className="w-full pl-11 pr-4 py-3.5 bg-ink-50 border-2 border-ink-100 focus:outline-none focus:border-athletic-500 text-ink-900 transition-colors" />
                  </div>
                </div>
                <button type="submit" className="w-full flex items-center justify-center gap-3 px-8 py-4 bg-athletic-500 hover:bg-athletic-600 text-white font-black uppercase tracking-wider transition-all">
                  Send Reset Link <ArrowRight className="w-4 h-4" />
                </button>
              </form>
            </>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ForgotPasswordPage;
